import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 617",
  "use": "icon-Path 617-usage",
  "viewBox": "0 0 20.6 12.875",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.6 12.875\" id=\"icon-Path 617\">\n  <path id=\"icon-Path 617_Path_617\" data-name=\"Path 617\" d=\"M10.3,96A11.536,11.536,0,0,0,0,102.438a11.459,11.459,0,0,0,20.6,0A11.537,11.537,0,0,0,10.3,96Zm5.079,3.414a9.8,9.8,0,0,1,3.006,3.024,9.8,9.8,0,0,1-3.006,3.024,9.439,9.439,0,0,1-10.157,0,9.8,9.8,0,0,1-3.006-3.024,9.8,9.8,0,0,1,3.006-3.024c.079-.05.158-.1.239-.147a5.15,5.15,0,1,0,9.68,0Q15.26,99.339,15.379,99.414Zm-5.079.972a1.931,1.931,0,1,1-1.931-1.931A1.931,1.931,0,0,1,10.3,100.386Z\" transform=\"translate(0 -96)\" fill=\"#e13133\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 617.svg
// module id = fGCe
// module chunks = 3